// extracted by mini-css-extract-plugin
export var container = "_5s-1";
export var cornerButtonContainer = "_5s-5";
export var disabled = "_5s-2";
export var fileContainer = "_5s-4";
export var hiddenInput = "_5s-3";
export var widthContainer = "_5s-0";